export const createBackpackhtml = (items) => {
  const wrapper = document.createElement('div');
  wrapper.id = 'backpack-mesh';
  wrapper.className = 'backpack-mesh-wrapper';

  const container = document.createElement('div');
  container.className = 'backpack-mesh';
  wrapper.appendChild(container);

  const header = document.createElement('div');
  header.className = 'backpack-mesh-header';
  header.innerHTML = 'Backpack';

  const content = document.createElement('div');
  content.className = 'backpack-mesh-content';

  const itemElements = [];
  items.forEach((item) => {
    const count = document.createElement('p');
    count.className = 'backpack-mesh-item';
    count.id = item.name;
    count.innerHTML = `${item.name} ${item.collected.length}/${item.solution.split('|').length}`;
    content.appendChild(count);
    itemElements.push({ name: item.name, ref: count });
  });

  container.appendChild(header);
  container.appendChild(content);
  document.body.appendChild(wrapper);
  return { html: wrapper, refs: { header, content, itemElements } };
};
